interface KeyMetricsCardProps {
  title: string;
  value: string;
  change?: number | null;
  subtitle?: string;
  isPositiveGood?: boolean;
  testId?: string;
}

export function KeyMetricsCard({
  title,
  value,
  change,
  subtitle,
  isPositiveGood = false,
  testId,
}: KeyMetricsCardProps) {
  const hasChange = change !== null && change !== undefined;

  let changeColor = 'text-mid-gray';
  let arrow = '';

  if (hasChange) {
    const isPositive = change > 0;
    const isNegative = change < 0;

    if (isPositiveGood) {
      if (isPositive) {
        changeColor = 'text-green-600';
        arrow = '▲';
      } else if (isNegative) {
        changeColor = 'text-red-600';
        arrow = '▼';
      }
    } else {
      if (isPositive) {
        changeColor = 'text-red-600';
        arrow = '▲';
      } else if (isNegative) {
        changeColor = 'text-green-600';
        arrow = '▼';
      }
    }
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-4" data-testid={testId}>
      <p className="text-sm text-mid-gray mb-1">{title}</p>
      <p
        className="text-2xl font-bold text-near-black"
        data-testid={testId ? `${testId}-value` : undefined}
      >
        {value}
      </p>
      {(hasChange || subtitle) && (
        <div className="flex items-center gap-1 mt-1">
          {hasChange && (
            <span className={`text-sm font-medium ${changeColor}`}>
              {arrow} {Math.abs(change).toFixed(0)}%
            </span>
          )}
          {subtitle && (
            <span className="text-xs text-mid-gray">{subtitle}</span>
          )}
        </div>
      )}
    </div>
  );
}
